import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Spin,
  Typography,
} from 'antd';
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import useScreenSize from '../../hooks/useScreenSize';
import { API, BEARER } from '../../constant';
import { setToken, setUserDetails } from '../../helpers';

const SignUp = () => {
  const navigate = useNavigate();
  const { isDesktopView } = useScreenSize();

  const { setUser } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState('');

  const onFinish = async (values) => {
    // console.log(values, '32');
    // return;
    setIsLoading(true);
    const newUserData = {
      ...values,
      roles_permisions: [2],
    };

    try {
      const response = await fetch(`${API}/auth/local/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newUserData),
      });

      const data = await response.json();
      if (data?.error) {
        throw data?.error;
      } else {
        // set the token
        setToken(data.jwt);
        try {
          const response = await fetch(`${API}/users/me?populate=*`, {
            headers: { Authorization: `${BEARER} ${data.jwt}` },
          });
          const userDetails = await response.json();
          let rolesAssignedArray = userDetails.roles_permisions;
          let rolesAssigned = [];
          rolesAssignedArray.map((rolesAssigneditem) => {
            rolesAssigned.push(rolesAssigneditem.role_id);
          });
          console.log('roles Assigned : ', rolesAssigned);
          userDetails.rolesAssigned = rolesAssigned;
          console.log(userDetails);
          setUserDetails(userDetails);

          // set the user
          setUser(userDetails);
        } catch (e) {
          message.error(`Something Went Wrong, please try again later!`);
        }
        // set the user
        setUser(data.user);

        message.success(`Welcome to PLM ${data.user.username}!`);

        navigate('/dashboard');
      }
    } catch (error) {
      console.error(error);
      setError(error?.message ?? 'Something went wrong!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Row align="middle">
        <Col span={isDesktopView ? 8 : 24} offset={isDesktopView ? 8 : 0}>
          <Card title="SignUp">
            {error ? (
              <Alert
                className="alert_error"
                message={error}
                type="error"
                closable
                afterClose={() => setError('')}
              />
            ) : null}
            <Form
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  {
                    required: true,
                    type: 'string',
                  },
                ]}
              >
                <Input placeholder="Username" />
              </Form.Item>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    type: 'email',
                  },
                ]}
              >
                <Input placeholder="Email address" />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true }]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login_submit_btn"
                >
                  Submit {isLoading && <Spin size="small" />}
                </Button>
              </Form.Item>
            </Form>
            <Typography.Paragraph className="form_help_text">
              Already have an account? <Link to="/signin">Sign In</Link>
            </Typography.Paragraph>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default SignUp;
